import { createAction } from '@reduxjs/toolkit'

import type { TDashboardFolderDto } from '@homepal/api-contract'

// tryGetAllDashboardFolders
export const getAll = createAction('get_all_dashboard_folders')
export const getAllSuccess = createAction<TDashboardFolderDto[]>(
  'get_all_dashboard_folders_success'
)
export const getAllFailed = createAction('get_all_dashboard_folders_failed')

// tryCreateDashboardFolder
export const create = createAction('create_dashboard_folder')
export const createSuccess = createAction<TDashboardFolderDto>(
  'create_dashboard_folder_success'
)
export const createFailed = createAction('create_dashboard_folder_failed')

// tryUpdateDashboardFolder
export const update = createAction('update_dashboard_folder')
export const updateSuccess = createAction<TDashboardFolderDto>(
  'update_dashboard_folder_success'
)
export const updateFailed = createAction('update_dashboard_folder_failed')

// tryDeleteDashboardFolder
export const destroy = createAction('delete_dashboard_folder')
export const destroySuccess = createAction<string>(
  'delete_dashboard_folder_success'
)
export const destroyFailed = createAction('delete_dashboard_folder_failed')
